module.exports = __webpack_public_path__ + "img/I2C_Fig08.4dc29a97.png";